import(/* webpackMode: "eager" */ "/var/www/tripcraftmx/frontend/src/app/[locale]/experiencias/[id]/page.tsx");
